export default "<div class=\"remplissage\">\n  {{niveauToDisplay}}\n</div>\n\n";